import JiraLogo from "../../images/logos/jira-logo.png";
import './issue-collector.scss';
import { useEffect } from "react";
import { useTypedSelector } from "../../store/reducers/use-typed-selector";

const IssueCollector: React.FC = () => {

	const { user } = useTypedSelector(state => ({
		user: state.AuthReducer.user
	}));

	useEffect(() => {
		if (
			(process.env.REACT_APP_BASE_URL !== 'https://brandlive.com') &&
			process.env.REACT_APP_JIRA_ENDPOINT
		) {
			//check to see if script already exists before loading
			const scripts = document.getElementsByTagName('script');
			for (let i = scripts.length; i--;) {
				if (scripts[i].src == process.env.REACT_APP_JIRA_ENDPOINT) {
					return;
				}
			}

			// props passed into script html
			const pageProps = `
			window.ATL_JQ_PAGE_PROPS = {
					triggerFunction: function(showCollectorDialog) {
						window.showCollectorDialog = showCollectorDialog
					},
					fieldValues: {
						fullname: '${user?.profile?.first_name || ''} ${user?.profile?.last_name || ''}',
						email: '${user?.email || ''}',
						recordWebInfo: '1',
						recordWebInfoConsent: ['1']
					}
				};
			`;

			// script does not exist on page, load script
			const script = document.createElement('script');
			script.src = process.env.REACT_APP_JIRA_ENDPOINT;
			document.body.appendChild(script);
			const scriptPageProps = document.createElement('script');
			scriptPageProps.innerHTML = pageProps;
			document.body.appendChild(scriptPageProps);
		}
	}, [user]);

	const click = () => {
		// invoke function to open issue collector popup
		(window as any).showCollectorDialog();
	};

	if (
		(process.env.REACT_APP_BASE_URL !== 'https://brandlive.com') &&
		process.env.REACT_APP_JIRA_ENDPOINT
	) {
		return (
			<button className="no-style issue-collector-button" onClick={click}>
				<div className="profile-pic issue-collector-icon">
					<img src={JiraLogo} alt="Jira" height="30" ></img>
				</div>
			</button>
		);
	} else return <></>;
};

export default IssueCollector;